<template>
  <div id="global" @mouseover="headerBorderBlack($event)">
    <main>
      <header class="h-350px">
        <nav class="mw-1300 global-menu">
          <div class="w-200px h-300px mr-auto">
            <img class="carrot_logo_img pointer" src="@/assets/img/global/logo.png" @click="handleGlobal" alt="로고" />
          </div>

          <div class="carrotlogo dp-flex flex-space-between">
            <div class="dropdown w-150px txt-center h-300px pr-45px">
              <span class="dropbtn pointer">글로벌 역량강화</span>
              <div class="dropdown-content">
                <a class="mt-40px pointer sub-menu-point" @click="handleGlobalSubPage1('Communication')">커뮤니케이션 역량</a>
                <a class="pointer sub-menu-point" @click="handleGlobalSubPage1('Skill')">비즈니스 스킬 역량</a>
                <a class="pointer sub-menu-point line-he20" @click="handleGlobalSubPage1('Duty')"
                  >글로벌 직무 역량<br />
                  및 전문가 양성</a
                >
                <a class="pointer sub-menu-point line-he20 pt-10px" @click="handleGlobalSubPage1('Dispatch')"
                  >주재원 및 현채인<br />
                  통합 솔루션</a
                >
                <a class="pointer sub-menu-point" @click="handleGlobalSubPage1('Crossculture')">이문화</a>
                <!-- <a class="pointer sub-menu-point" @click="handleGlobalSubPage1('Relocationhelp')">리로케이션지원</a> -->
              </div>
            </div>

            <div class="dropdown w-150px txt-center h-300px pr-45px">
              <span class="dropbtn pointer sub-menu-point"
                >맞춤 컨설팅 및<br />
                맞춤콘텐츠 개발</span
              >
              <div class="dropdown-content">
                <a class="mt-47px pointer sub-menu-point line-he20" @click="handleGlobalSubPage6('Contentdev')">맞춤컨설팅 및 맞춤 콘텐츠 개발</a>
              </div>
            </div>

            <div class="dropdown h-300px pr-45px">
              <span class="dropbtn pointer sub-menu-point">리더십 및 조직문화 강화 </span>
              <div class="dropdown-content">
                <a class="mt-40px pointer sub-menu-point" @click="handleGlobalSubPage2('Leadership')">리더십</a>
                <a class="pointer sub-menu-point" @click="handleGlobalSubPage2('Coaching')">코칭</a>
                <a class="pointer sub-menu-point" @click="handleGlobalSubPage2('Lifeplan')">생애설계/재취업</a>
                <a class="pointer sub-menu-point" @click="handleGlobalSubPage2('Customconsulting')">조직활성화</a>
              </div>
            </div>

            <div class="dropdown h-300px pr-45px">
              <span class="dropbtn pointer sub-menu-point">디지털 역량 강화 </span>
              <div class="dropdown-content">
                <a class="mt-40px sub-menu-point pointer" @click="handleGlobalSubPage3('DT')">DT</a>
              </div>
            </div>

            <div class="dropdown h-300px pr-45px">
              <span class="dropbtn sub-menu-point">평가 및 진단</span>
              <div class="dropdown-content">
                <a class="mt-40px pointer sub-menu-point" @click="handleGlobalSubPage4('Globalcompetence')">글로벌 역량 진단</a>
                <a class="pointer sub-menu-point" @click="handleGlobalSubPage4('Leadershipcompetency')">리더십 역량 진단</a>
                <a class="pointer sub-menu-point" @click="handleGlobalSubPage4('Organizationalcompetency')">조직 진단</a>
                <!-- <a class="pointer sub-menu-point" @click="handleGlobalSubPage4('Diagnosisdev')">맞춤진단개발</a> -->
              </div>
            </div>

            <div class="dropdown w-150px txt-center h-300px pr-45px">
              <span class="dropbtn sub-menu-point"
                >해외 연수<br />
                프로그램
              </span>
              <div class="dropdown-content">
                <a class="mt-47px pointer sub-menu-point line-he20" @click="handleGlobalSubPage5('Siliconvalley')"
                  >실리콘밸리<br />
                  On-Stie 코스</a
                >
                <!-- <a class="pointer sub-menu-point" @click="handleGlobalSubPage5('Localexpert')">지역전문가</a> -->
                <!-- <a class="pointer sub-menu-point" @click="handleGlobalSubPage5('Localcustomconsulting')">맞춤 컨설팅</a> -->
              </div>
            </div>

            <div class="dropdown w-123px txt-center h-300px pr-45px">
              <span class="dropbtn sub-menu-point">회사 소개</span>
              <div class="dropdown-content">
                <a class="mt-40px pointer sub-menu-point" @click="clickMore('https://carrotglobal.com/')">CARROT HUB</a>
                <a class="pointer sub-menu-point" @click="clickMore('https://carrotenglish.com/carrot/index.html')">회사소개</a>
                <!-- <a class="pointer sub-menu-point" @click="clickMore('https://www.carrotglobal.com/global/?contact=true')">교육문의</a> -->
                <a class="pointer sub-menu-point" @click="handleGotoQa">교육문의</a>
                <a class="pointer sub-menu-point" @click="clickMore('https://job.carrotenglish.net')">강사 지원</a>
                <a class="pointer sub-menu-point" @click="clickMore('https://biz.carrotenglish.com/news-letter')">사보 당근농장</a>
              </div>
            </div>
          </div>
        </nav>
        <div class="bar"></div>
      </header>
      <div class="width_margin_02">
        <div class="global_ability_title">맞춤 컨설팅 및 맞춤콘텐츠 개발</div>
        <div class="global_ability_sub_title">
          글로벌 비즈니스 환경에서 필요한 자사 맞춤 콘텐츠 개발부터<br class="br_1" />
          글로벌 교육 체계 컨설팅까지 가능합니다.
        </div>
      </div>
    </main>

    <div class="menu_bar_background">
      <div class="width_margin_03">
        <div class="menu_bar">
          <div class="menu_bar_left_section">맞춤 컨설팅</div>
          <div class="menu_bar_list_section pointer" @click="handleMenuList">
            <div class="menu_bar_right_select_container">
              <div v-if="isContentdev == true" class="select_container_left">맞춤컨설팅 및 맞춤 콘텐츠 개발</div>
              <div class="select_container_right">
                <img v-if="isShowMenu == false" class="pointer" src="@/assets/img/global/sub_page_down_arrow.png" />
                <img v-if="isShowMenu == true" class="pointer" src="@/assets/img/global/sub_page_min_icon.png" />
              </div>
              <div class="menu_bar_detail_list_section" v-if="isShowMenu">
                <!-- <div class="menu_bar_detail_list_name pointer" :style="isCommunication ? 'display: none;' : ''" @click="goToCommunication">커뮤니케이션</div> -->
                <div class="menu_bar_detail_list_name pointer" @click="goToCommunication">맞춤컨설팅 및 맞춤 콘텐츠 개발</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Contentdev v-if="isContentdev"></Contentdev>

    <!-- 풋터 -->
    <Footer></Footer>
  </div>
</template>

<script>
import Contentdev from "@/components/Global/Contentdev.vue";
import Footer from "@/components/Global/Footer.vue";

export default {
  components: {
    Contentdev,
    Footer,
  },
  data() {
    return {
      isContentdev: true,
      site: "",
      isShowMenu: false,
      showMenuList: [
        {
          communication: "커뮤니케이션",
          skill: "",
          duty: "",
        },
      ],
    };
  },
  mounted() {
    if (this.$route.query.name === "Contentdev") {
      this.isContentdev = true;
    }
  },
  methods: {
    headerBorderBlack(e) {
      let header = document.querySelector("header");
      let bar = document.querySelector(".bar");
      const dropbtn = document.querySelector(".dropbtn");
      const dropContent = document.querySelectorAll(".dropdown-content");

      let a = e.target;
      if (a === dropbtn || a === dropContent || a.classList.contains("sub-menu-point") || a.classList.contains("dropdown-content")) {
        header.classList.add("active");
        bar.classList.add("active");
        dropContent.forEach((item) => {
          item.classList.add("active");
        });
      } else {
        header.classList.remove("active");
        bar.classList.remove("active");
        dropContent.forEach((item) => {
          item.classList.remove("active");
        });
      }
    },
    handleGlobalSubPage1(name) {
      this.$router.push({ path: "/global-sub1", query: { name } }).catch(() => {});
    },
    handleGlobalSubPage2(name) {
      this.$router.push({ path: "/global-sub2", query: { name } }).catch(() => {});
    },
    handleGlobalSubPage3(name) {
      this.$router.push({ path: "/global-sub3", query: { name } }).catch(() => {});
    },
    handleGlobalSubPage4(name) {
      this.$router.push({ path: "/global-sub4", query: { name } }).catch(() => {});
    },
    handleGlobalSubPage5(name) {
      this.$router.push({ path: "/global-sub5", query: { name } }).catch(() => {});
    },
    handleGlobalSubPage6(name) {
      this.$router.push({ path: "/global-sub6", query: { name } }).catch(() => {});
    },
    handleGlobal() {
      this.$router.push({ path: "/global" });
    },
    clickMore(path) {
      window.open(path, "_blank");
    },
    changeSelectBox() {
      if (this.site) {
        window.open(this.site, "_blank");
      }
    },
    handleMenuList() {
      this.isShowMenu = !this.isShowMenu;
    },
    goToCommunication() {},
    handleGotoQa() {
      this.$router.push({ path: "/global#section_qa" });
    },
  },
};
</script>

<style lang="scss">
// 공통
a {
  display: inline-block;
}
.width_margin {
  width: 90%;
  margin: 0 auto;
}

#global {
  .width_margin_02 {
    width: 90%;
    margin: 0 auto;
  }

  .width_margin_03 {
    width: 90%;
    margin: 0 auto;
  }
  // 메인 상단
  main {
    background-size: cover;
    background: url(~@/assets/img/global/sub_page_bg.png) center/cover no-repeat;
    header {
      top: 0;
      left: 0;
      z-index: 1;
      width: 100%;
      position: absolute;
    }

    header.active {
      background-color: #000000;
      z-index: 99;
    }
    // content
    .global_ability_title {
      color: #fff;
      font-size: 60px;
      font-weight: bold;
      line-height: 1.45;
      padding-top: 180px;
      font-style: normal;
      text-align: center;
      font-stretch: normal;
      letter-spacing: -1.2px;
    }

    .global_ability_sub_title {
      font-size: 22px;
      color: #d4d4d4;
      line-height: 1.55;
      padding-top: 35px;
      font-style: normal;
      text-align: center;
      font-weight: normal;
      font-stretch: normal;
      padding-bottom: 170px;
      letter-spacing: -0.44px;
    }

    .bar {
      width: 100%;
      display: none;
      height: 1px;
      opacity: 0.3;
      border: solid 1px #fff;
      background-color: #fff;
      position: absolute;
      top: 83px;
    }

    .bar.active {
      display: inline-block;
    }

    .global-menu {
      display: flex;
      margin: 0 auto;
      padding-top: 33px;
      align-items: center;
      padding-bottom: 32px;
    }

    .dropdown {
      color: #fff;
      cursor: pointer;
      font-size: 15px;
      font-weight: 500;
      position: relative;
      display: inline-block;
    }

    .spac_box {
      display: flex;
      align-items: center;
      justify-content: space-around;
      background-color: rgba(0, 0, 0, 0.3);
      .spac_box_width_margin {
        width: 1300px;
        display: flex;
        margin: 0 auto;
        align-items: center;
        padding: 41px 0 33px 0;
        justify-content: space-between;
      }
    }
    .client {
      font-size: 20px;
      position: relative;
      color: rgba(255, 255, 255, 0.7);
    }
    .Languages {
      font-size: 20px;
      color: rgba(255, 255, 255, 0.7);
    }
    .instructors {
      font-size: 20px;
      color: rgba(255, 255, 255, 0.7);
    }
    .modules {
      font-size: 20px;
      color: rgba(255, 255, 255, 0.7);
    }
    .spac_num {
      color: #fff;
      font-size: 50px;
      font-weight: bold;
      .spac_num_plus {
        font-size: 40px;
        color: #ff5f07;
      }
    }

    .dropdown-content {
      top: 20px;
      width: 100%;
      display: none;
      position: absolute;
      text-align: center;
      padding-right: 45px;
      z-index: 1; /*다른 요소들보다 앞에 배치*/
    }

    .dropdown-content a {
      display: block;
      font-size: 13px;
      color: #838383;
      font-weight: 500;
      transition: 0.5s;
      line-height: 34px;
    }

    .dropdown-content.active {
      display: block;
    }

    .dropdown-content > a:hover {
      color: #ff5f07 !important;
    }
  }

  .menu_bar_background {
    background: #1d1d1d;
  }

  .body_container {
    .width_margin {
      width: 1300px;
      .container_content_list_title {
        color: #fff;
        font-size: 45px;
        text-align: left;
        font-weight: bold;
        line-height: 1.51;
        padding-top: 180px;
        font-style: normal;
        font-stretch: normal;
        padding-bottom: 54px;
        letter-spacing: -0.9px;
        border-bottom: 1px solid #ffffff;
      }

      .container_content_list {
        display: flex;
        margin: 0 32px 0 32px;
        padding: 31px 0 42px 0;
        justify-content: space-between;
        border-bottom: 1px solid rgba(176, 176, 176, 0.2);
        .container_content_list_img {
          position: relative;
          .container_content_list_box {
            left: 13px;
            top: 143px;
            position: absolute;
            .container_content_list_img_text {
              left: 3.7%;
              bottom: 11.3%;
              display: flex;
              align-items: center;
              border-radius: 22.5px;
              justify-content: center;
              background-color: rgba(0, 0, 0, 0.4);
              padding: 15px 16px 15px 15px;
              .container_content_list_left_icon {
                width: 10px;
                height: 10px;
                border-radius: 50%;
                margin-right: 9px;
                background-color: #ff5f07;
                border: 1px solid #ff5f07;
              }
              .container_content_list_right_text {
                color: #fff;
                font-size: 16px;
                font-weight: 500;
                line-height: 1;
                font-style: normal;
                font-stretch: normal;
                letter-spacing: -0.4px;
              }
            }
          }
        }
      }
      .container_content_list:last-child {
        padding-bottom: 219px;
        border-bottom: none;
      }
      .container_content_text_list {
        width: 774px;
        .container_content_text_title_down_container {
          display: flex;
          align-items: center;
          .container_content_text_title1 {
            color: #fff;
            font-size: 28px;
            text-align: left;
            font-weight: bold;
            line-height: 1.36;
            font-style: normal;
            padding-right: 20px;
            // padding-bottom: 10px;
            font-stretch: normal;
            letter-spacing: -0.56px;
          }
          .container_content_download {
            color: #fff;
            display: flex;
            font-size: 13px;
            font-weight: 500;
            line-height: 1.08;
            font-style: normal;
            align-items: center;
            font-stretch: normal;
            border-radius: 14.5px;
            justify-content: center;
            letter-spacing: -0.26px;
            padding: 9px 11px 9px 11px;
            background-color: #3d3d3d;
            .container_right_download_img {
              padding-right: 5px;
            }
          }
        }
        .container_content_text_title {
          font-size: 16px;
          color: #ff5f07;
          text-align: left;
          line-height: 1.69;
          font-style: normal;
          font-weight: normal;
          font-stretch: normal;
          padding-bottom: 26px;
          word-break: keep-all;
          letter-spacing: -0.4px;
          .container_content_text_title_span {
            font-weight: bold;
          }
        }
        .container_content_text_content {
          line-height: 2;
          font-size: 13px;
          text-align: left;
          color: #b0b0b0;
          font-style: normal;
          font-weight: normal;
          font-stretch: normal;
          letter-spacing: -0.33px;
        }
      }
    }
  }

  .menu_bar {
    max-width: 1300px;
    display: flex;
    margin: 0 auto;
    background-color: #1d1d1d;
    .menu_bar_left_section {
      color: #fff;
      line-height: 1;
      font-size: 16px;
      font-weight: 500;
      text-align: left;
      font-style: normal;
      font-stretch: normal;
      letter-spacing: -0.32px;
      padding: 34px 36px 34px 0;
    }
    .menu_bar_list_section {
      display: flex;
      .menu_bar_right_select_container {
        width: 310px;
        display: flex;
        position: relative;
        background: black;
        align-items: center;
        justify-content: space-around;
        .select_container_left {
          line-height: 2;
          font-size: 16px;
          font-weight: 500;
          color: #ff5f07;
          text-align: left;
          font-style: normal;
          font-stretch: normal;
          letter-spacing: -0.32px;
        }
        .menu_bar_detail_list_section {
          top: 85px;
          z-index: 2;
          width: 310px;
          position: absolute;
          background-color: #fafafa;
          padding: 0 12px 0 12px;
          .menu_bar_detail_list_name {
            font-size: 16px;
            font-weight: 500;
            padding: 18px 0 18px 23px;
            border-bottom: 1px solid #bebebe;
          }
          // .menu_bar_detail_list_name:first-child {
          //   margin: 0px;
          //   padding: 0px;
          // }
          .menu_bar_detail_list_name:last-child {
            border-bottom: none;
          }
        }
      }
    }
  }

  .body_container {
    background-color: #000000;
  }

  .section_08 {
    height: 363px;
    background-color: #323232;
    .section_08_aboutus_faq_container {
      display: flex;
      padding-top: 57px;
      align-items: center;
      padding-bottom: 18px;
      justify-content: space-between;
      .section_08_aboutus_faq_box {
        display: flex;
        font-size: 15px;
        line-height: 1.4;
        text-align: left;
        color: #686868;
        font-style: normal;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: -0.75px;

        .section_08_aboutus {
          position: relative;
          padding-right: 10px;
          &::after {
            content: "";
            position: absolute;
            top: 2px;
            right: 4px;
            width: 1.5px;
            height: 80%;
            background: #80898e;
          }
        }
        .section_08_faq {
        }
      }
      .section_08_sns_box {
        display: flex;
        font-size: 15px;
        line-height: 1.4;
        text-align: left;
        color: #686868;
        font-style: normal;
        padding-right: 9px;
        align-items: center;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: -0.75px;

        .section_08_follow {
          padding-right: 9px;
        }
        img {
          padding-right: 9px;
        }
        .section_08_selectbox {
          width: 210px;
          height: 46px;
          font-size: 15px;
          line-height: 1.4;
          color: #686868;
          margin-left: 25px;
          font-style: normal;
          font-weight: normal;
          font-stretch: normal;
          padding-left: 17px;
          letter-spacing: -0.75px;
          background-color: #fff !important;
          background: url(~@/assets/img/global/icon_downarrow.png) no-repeat 95% 50%/12px auto;
        }
      }
    }
    .section_08_line {
      opacity: 0.3;
      border-bottom: 1px solid #686868;
    }
    .section_08_tel_email_address_box {
      display: flex;
      font-size: 15px;
      line-height: 1.4;
      color: #686868;
      padding-top: 37px;
      font-style: normal;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: -0.75px;
      .section_08_tel_email_mobile {
        display: none;
      }

      .section_08_tel {
        position: relative;
        padding-right: 10px;
        &::after {
          content: "";
          position: absolute;
          top: 3px;
          right: 4px;
          width: 1px;
          height: 75%;
          background: #80898e;
        }
      }
      .section_08_email {
        padding-right: 15px;
      }
      .section_08_address {
      }
    }
    .section_08_ceo_reserved_box {
      color: #686868;
      font-size: 15px;
      line-height: 1.4;
      font-style: normal;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: -0.75px;

      .section_08_ceo {
      }
      .section_08_reserved {
      }
    }
  }

  // 1300px 이하
  @media only screen and (max-width: 1300px) {
    .width_margin {
      width: auto !important;
      margin: 0 auto;
    }
    .h-350px {
      .carrot_logo_img {
        position: absolute;
        top: 5%;
        left: 11%;
      }
      .carrotlogo {
        display: none;
      }
    }
    .width_margin_02 {
      width: 90%;
      .global_ability_sub_title {
        word-break: keep-all;
        .br_1 {
          display: none;
        }
      }
    }
    .width_margin {
      width: 90%;
      display: flex;
      flex-wrap: wrap;
      padding: 31px 32px 42px 32px;
      justify-content: space-between;
      .container_content_list_title {
        width: 100%;
      }
      .container_content_list {
        width: 47.5%;
        margin: 0 !important;
        padding: 0 !important;
        flex-direction: column;
        border-bottom: none !important;
        justify-content: flex-start !important;
        .container_content_list_img {
          width: 100%;
          img {
            width: 100%;
          }
          .container_content_list_box {
            .container_content_list_img_text {
              display: none !important;
              .container_content_list_left_icon {
                display: none;
              }
              .container_content_list_right_text {
                display: none;
              }
            }
          }
        }
        .container_content_text_list {
          width: 100% !important;
          .container_content_text_title_down_container {
            flex-direction: column;
            align-items: flex-start;
            .container_content_text_title1 {
              font-size: 25px;
              color: #ff5f07;
              padding-top: 18px;
              padding-bottom: 10px;
            }
          }
          .container_content_text_title {
            padding-top: 13px;
            font-size: 15px;
            color: #b0b0b0;
          }
          .container_content_text_content {
            display: none;
          }
        }
      }
    }
    .menu_bar_background {
      .width_margin_03 {
        width: 90%;
        margin: 0 auto;
      }
    }
    .section_08 {
      .width_margin {
        display: block;
      }
    }
  }

  @media only screen and (max-width: 850px) {
    .section_08 {
      .width_margin {
        .section_08_aboutus_faq_container {
          padding-top: 59px;
          flex-direction: column;
          align-items: flex-start;
          .section_08_aboutus_faq_box {
            font-size: 13px;
            padding-bottom: 15px;
            .section_08_aboutus {
              &::after {
                content: "";
                position: absolute;
                top: 2px;
                right: 4px;
                width: 1.5px;
                height: 71%;
                background: #80898e;
              }
            }
            .section_08_faq {
            }
          }
          .section_08_sns_box {
            flex-direction: column;
            align-items: flex-start;
            .section_08_follow {
              font-size: 13px;
              padding-bottom: 23px;
            }
            .section_08_selectbox {
              font-size: 13px;
              margin-top: 23px;
              margin-left: 0px;
              padding-left: 18px;
            }
          }
        }
      }
      .section_08_line {
      }
      .width_margin {
        .section_08_tel_email_address_box {
          font-size: 13px;
          flex-direction: column;
          .section_08_tel {
            display: none;
          }
          .section_08_email {
            display: none;
          }
          .section_08_tel_email_mobile {
            display: flex;
            // display: block;
          }
          .section_08_tel_mobile {
            position: relative;
            padding-right: 10px;
            &::after {
              content: "";
              top: 2px;
              right: 4px;
              height: 71%;
              width: 1.5px;
              position: absolute;
              background: #80898e;
            }
            .section_08_email_mobile {
            }
          }
          .section_08_address {
          }
        }
        .section_08_ceo_reserved_box {
          font-size: 13px;
          .section_08_ceo {
          }
          .section_08_reserved {
          }
        }
      }
    }
  }

  // 700px 이하
  @media only screen and (max-width: 700px) {
    .width_margin_02 {
      display: flex;
      flex-direction: column;
      justify-content: center;
      .global_ability_title {
        color: #fff;
        font-size: 45px;
        font-weight: bold;
        line-height: 1.93;
        font-style: normal;
        font-stretch: normal;
        letter-spacing: -0.9px;
      }
      .global_ability_sub_title {
        font-size: 18px;
        color: #d4d4d4;
        line-height: 1.44;
        font-style: normal;
        text-align: center;
        font-weight: normal;
        word-break: keep-all;
        font-stretch: normal;
        letter-spacing: -0.36px;
      }
    }
    .menu_bar_background {
      .width_margin_03 {
        margin: 0;
        .menu_bar {
          .menu_bar_left_section {
            display: none;
          }
          .menu_bar_right_select_container {
            .select_container_left {
              padding: 28px 0 39px 0;
              font-size: 16px;
            }
          }
        }
      }
    }
    .body_container {
      .width_margin {
        .container_content_list_title {
          font-size: 30px;
          padding-top: 94px;
        }
      }
      .width_margin {
        display: flex;
        flex-direction: column;
        .container_content_list {
          margin: 0;
          width: 100%;
          padding: 31px 9px 0 9px;
          .container_content_list_img {
            padding: 0;
          }
          .container_content_text_list {
            .container_content_text_title_down_container {
              .container_content_text_title1 {
                font-size: 20px;
              }
            }
            .container_content_text_title {
              font-size: 13px;
              color: #b0b0b0;
              line-height: 1.46;
              font-style: normal;
              font-weight: normal;
              padding-bottom: 23px;
              font-stretch: normal;
              letter-spacing: -0.33px;
            }
          }
        }
      }
    }
    .section_08 {
      height: 100%;
      .width_margin_04 {
        .section_08_aboutus_faq_container {
          padding-bottom: 15px;
          flex-direction: column;
          .section_08_aboutus_faq_box {
            .section_08_aboutus {
              padding-bottom: 15px;
              &::after {
                content: "";
                position: absolute;
                top: 2px;
                right: 4px;
                width: 1.5px;
                height: 46%;
                background: #80898e;
              }
            }
          }
          .section_08_sns_box {
            .section_08_selectbox {
              padding-left: 17px;
              margin: 23px 0 0 0;
            }
          }
        }
      }
      .width_margin {
        justify-content: flex-start;
        .section_08_tel_email_address_box {
          flex-direction: column;
          .section_08_tel {
            display: none;
          }
          .section_08_email {
            display: none;
          }
          .section_08_tel_email_mobile {
            display: flex;
            font-size: 13px;
            .section_08_tel_mobile {
              position: relative;
              padding-right: 10px;
              &::after {
                content: "";
                position: absolute;
                top: 2px;
                right: 4px;
                width: 1.5px;
                height: 70%;
                background: #80898e;
              }
            }
          }
          .section_08_address {
            font-size: 13px;
          }
        }
        .section_08_ceo_reserved_box {
          font-size: 13px;
          .section_08_reserved {
            padding-bottom: 15px;
          }
        }
      }
    }
  }

  // 360px 이하
  @media only screen and (max-width: 360px) {
    .width_margin_02 {
      display: flex;
      flex-direction: column;
      justify-content: center;
      .global_ability_title {
        color: #fff;
        font-size: 45px;
        font-weight: bold;
        line-height: 1.93;
        font-style: normal;
        font-stretch: normal;
        letter-spacing: -0.9px;
      }
      .global_ability_sub_title {
        font-size: 18px;
        color: #d4d4d4;
        line-height: 1.44;
        font-style: normal;
        text-align: center;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: -0.36px;
      }
    }
    .menu_bar_background {
      .width_margin_03 {
        margin: 0;
        .menu_bar {
          .menu_bar_left_section {
            display: none;
          }
          .menu_bar_right_select_container {
            .select_container_left {
              padding: 28px 0 39px 0;
              font-size: 16px;
            }
          }
        }
      }
    }
    .body_container {
      .width_margin {
        .container_content_list_title {
          font-size: 30px;
          padding-top: 94px;
        }
      }
      .width_margin {
        display: flex;
        padding: 0;
        flex-direction: column;
        .container_content_list {
          margin: 0;
          width: 100%;
          padding: 31px 9px 0 9px;
          .container_content_list_img {
            padding: 0;
          }
          .container_content_text_list {
            .container_content_text_title_down_container {
              .container_content_text_title1 {
                font-size: 20px;
              }
            }
            .container_content_text_title {
              font-size: 13px;
              color: #b0b0b0;
              line-height: 1.46;
              font-style: normal;
              font-weight: normal;
              padding-bottom: 23px;
              font-stretch: normal;
              letter-spacing: -0.33px;
            }
          }
        }
      }
    }
    .section_08 {
      height: 100%;
      .width_margin_04 {
        .section_08_aboutus_faq_container {
          padding-bottom: 21px;
          flex-direction: column;
          .section_08_aboutus_faq_box {
            .section_08_aboutus {
              padding-bottom: 15px;
              &::after {
                content: "";
                position: absolute;
                top: 2px;
                right: 4px;
                width: 1.5px;
                height: 17% !important;
                background: #80898e;
              }
            }
          }
          .section_08_sns_box {
            .section_08_selectbox {
              padding-left: 17px;
              margin: 23px 0 0 0;
            }
          }
        }
      }
      .width_margin_04 {
        justify-content: flex-start;
        .section_08_tel_email_address_box {
          flex-direction: column;
          .section_08_tel {
            display: none;
          }
          .section_08_email {
            display: none;
          }
          .section_08_tel_email_mobile {
            display: flex;
            font-size: 13px;
            .section_08_tel_mobile {
              position: relative;
              padding-right: 10px;
              &::after {
                content: "";
                position: absolute;
                top: 2px;
                right: 4px;
                width: 1.5px;
                height: 70%;
                background: #80898e;
              }
            }
          }
          .section_08_address {
            font-size: 13px;
          }
        }
        .section_08_ceo_reserved_box {
          font-size: 13px;
          .section_08_reserved {
            padding-bottom: 15px;
          }
        }
      }
    }
  }
}
</style>
